import styled from 'styled-components';
import { Box } from '@user-portal/wikr-components';

import { color } from 'theme/selectors';
import mediaQueries from 'theme/mediaQueries';

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 32px 16px;
    gap: 16px;
    align-items: center;
    max-width: 432px;
    margin: 0 auto;
`;

export const ModalHeaderTitle = styled.div`
    position: fixed;
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    padding: 16px;
    background: ${color('surface-main')};
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    border-bottom: 1px solid ${color('border-default')};

    ${mediaQueries.laptop} {
        padding: 16px 40px;
    }
`;

export const ModalContent = styled.div`
    height: 100%;
    padding: 70px 8px 32px;
    overflow: hidden;
    background: ${color('surface-main')};

    ${mediaQueries.largeTablet} {
        padding: 70px 0px 32px;
    }
`;

export const TitleText = styled.div`
    flex: 1;
`;

export const DiscountsContainer = styled.div`
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${color('surface-secondary')};
    height: 44px;
    width: 44px;
    border-radius: 50%;

    &:hover {
        cursor: pointer;
    }
`;

export const Form = styled.form`
    width: 100%;
`;

export const ContentBlock = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const TextAreaTip = styled(Box)`
    display: flex;
    justify-content: space-between;
`;

export const Textarea = styled.textarea<{ hasError: boolean }>`
    width: 100%;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 16px;
    border-width: 1px;
    resize: none;
    border-radius: ${({ theme }) => `${theme['border-radius-medium']}px`};
    background-color: ${color('surface-default')};
    border-color: ${({ hasError }) => (!hasError ? color('surface-default') : color('critical-default'))};
    color: ${color('text-main')};

    &:focus {
        background-color: ${color('surface-hovered')};
        border-color: ${({ hasError }) => (!hasError ? color('safe') : color('critical-default'))};
        outline: none;
    }

    &:disabled {
        background-color: ${color('surface-secondary')};
        border-color: transparent;
    }

    &:disabled::placeholder,
    &:disabled {
        color: ${color('text-secondary-subdued')};
    }
`;
